import { getService } from '@/modules/Service/services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useParams } from 'react-router-dom'
import Templates from '../../Templates'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Setting = () => {
    const { id: serviceID } = useParams()
    const { data: service, renderState } = useQueryWithHandler({
        queryFn: () => getService(Number(serviceID)),
        queryKey: [QUERY_KEYS.SERVICE_DETAIL, Number(serviceID)],
    })
    console.log(service)

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    if (!service) return null

    const ServiceTemplate =
        Templates[service?.service_template] || Templates['Blank']

    const Setting =
        //@ts-ignore
        ServiceTemplate?.Setting || Templates['Blank']?.Setting

    return <Setting service={service} />
}

export default Setting
